/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Brokers_YouInputs */

const cs_calendar_brokers_you = /** @type {(inputs: Calendar_Brokers_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vy`)
};

const en_calendar_brokers_you = /** @type {(inputs: Calendar_Brokers_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you`)
};

/**
* | output |
* | --- |
* | "you" |
*
* @param {Calendar_Brokers_YouInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_brokers_you = /** @type {((inputs?: Calendar_Brokers_YouInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Brokers_YouInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_brokers_you(inputs)
	return cs_calendar_brokers_you(inputs)
});